// AUTO-GENERATED by scripts/generate-lucide-icons.js — do not edit manually
// 143 icons detected from source scan
//
// To regenerate: node scripts/generate-lucide-icons.js
// To check if up-to-date: node scripts/generate-lucide-icons.js --check

import { createIcons, Activity, AlertCircle, AlertTriangle, ArrowLeft, ArrowRight, ArrowUpDown, Asterisk, AtSign, Ban, Bell, BellOff, BookOpen, Bookmark, BookmarkMinus, Box, Briefcase, Bug, Building, Cake, Calendar, Camera, Check, CheckCheck, CheckCircle, ChevronDown, ChevronLeft, ChevronRight, ChevronsDownUp, Circle, CircleAlert, CircleCheck, CircleHelp, CirclePlay, CircleStop, Clock, Code, Coffee, Compass, Cookie, Crop, Ellipsis, EllipsisVertical, ExternalLink, Eye, EyeOff, FileText, Film, Filter, Flag, Folder, FolderInput, Gamepad2, Globe, GraduationCap, Grid2x2, Handshake, Headphones, Heart, HeartHandshake, HelpCircle, Home, Image, ImageOff, ImagePlus, Images, Inbox, Info, Key, Languages, Laptop, Lightbulb, Link, List, Loader2, Lock, LogIn, LogOut, Mail, MailWarning, MapPin, Megaphone, MessageCircle, MessageCircleHeart, MessageCircleOff, MessageSquare, MessageSquarePlus, MessagesSquare, Mic, MoreHorizontal, Music, Newspaper, Palette, Paperclip, PartyPopper, Pause, Pencil, PencilLine, Pill, Plane, Play, Plus, Radio, RefreshCw, Repeat, Reply, RotateCcw, Scale, ScrollText, Search, SearchX, Send, Settings, Settings2, Share, Shield, ShieldAlert, ShieldCheck, SlidersHorizontal, Smartphone, Smile, Sparkles, SquarePen, Star, Sun, Tag, Target, Trash2, TriangleAlert, Trophy, Truck, Type, Undo2, User, UserCheck, UserCircle, UserCog, UserMinus, UserPlus, UserX, Users, Users2, Utensils, X } from 'lucide';

export const icons = {
    Activity,
    AlertCircle,
    AlertTriangle,
    ArrowLeft,
    ArrowRight,
    ArrowUpDown,
    Asterisk,
    AtSign,
    Ban,
    Bell,
    BellOff,
    BookOpen,
    Bookmark,
    BookmarkMinus,
    Box,
    Briefcase,
    Bug,
    Building,
    Cake,
    Calendar,
    Camera,
    Check,
    CheckCheck,
    CheckCircle,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsDownUp,
    Circle,
    CircleAlert,
    CircleCheck,
    CircleHelp,
    CirclePlay,
    CircleStop,
    Clock,
    Code,
    Coffee,
    Compass,
    Cookie,
    Crop,
    Ellipsis,
    EllipsisVertical,
    ExternalLink,
    Eye,
    EyeOff,
    FileText,
    Film,
    Filter,
    Flag,
    Folder,
    FolderInput,
    Gamepad2,
    Globe,
    GraduationCap,
    Grid2x2,
    Handshake,
    Headphones,
    Heart,
    HeartHandshake,
    HelpCircle,
    Home,
    Image,
    ImageOff,
    ImagePlus,
    Images,
    Inbox,
    Info,
    Key,
    Languages,
    Laptop,
    Lightbulb,
    Link,
    List,
    Loader2,
    Lock,
    LogIn,
    LogOut,
    Mail,
    MailWarning,
    MapPin,
    Megaphone,
    MessageCircle,
    MessageCircleHeart,
    MessageCircleOff,
    MessageSquare,
    MessageSquarePlus,
    MessagesSquare,
    Mic,
    MoreHorizontal,
    Music,
    Newspaper,
    Palette,
    Paperclip,
    PartyPopper,
    Pause,
    Pencil,
    PencilLine,
    Pill,
    Plane,
    Play,
    Plus,
    Radio,
    RefreshCw,
    Repeat,
    Reply,
    RotateCcw,
    Scale,
    ScrollText,
    Search,
    SearchX,
    Send,
    Settings,
    Settings2,
    Share,
    Shield,
    ShieldAlert,
    ShieldCheck,
    SlidersHorizontal,
    Smartphone,
    Smile,
    Sparkles,
    SquarePen,
    Star,
    Sun,
    Tag,
    Target,
    Trash2,
    TriangleAlert,
    Trophy,
    Truck,
    Type,
    Undo2,
    User,
    UserCheck,
    UserCircle,
    UserCog,
    UserMinus,
    UserPlus,
    UserX,
    Users,
    Users2,
    Utensils,
    X
};

export { createIcons };
